import Cookie from '../middleware/cookie';
import ENV from '../../env';

const userSessionCookie = new Cookie(
  ENV.PUSHBOT_USER_SESSION_PATH,
  { options: { expires: 7 } },
  { prefix: 'UserSession', paths: ['feature'] }
);

export default userSessionCookie;



// WEBPACK FOOTER //
// ./js/store/config/userSessionCookie.js